/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from "react";
import { Form } from "react-bootstrap";
import FormSelectBox from "../formSelectBox/FormSelectBox";
import TagInput from "../tagInput/TagInput";
import momentJalaali from "jalali-moment";
import {
    removeCamma,
    toEnglishNum,
    persianToEnglishNumber,
} from "utils/helpers";
import { GeneralDataContext } from "store/GeneralContext";
import style from "./Input.module.scss";
import { InputProps, InputTypes } from "./Input.props";
import DatePicker from "components/DatePicker";
import { FileUploader } from "components";

const Input: React.FC<InputProps> = ({
    input,
    defaultValue,
    handleChange,
    reset = false,
    disabled,
    startDate,
    costumeTitle,
    hasError,
    hasNotShowAll,
}) => {
    const [inputValue, setInputValue] = useState(defaultValue);
    const [isValid, setIsValid] = useState(true);
    const [isPersianNumber, setIsPersianNumber] = useState(false);
    const [errorMessage, setErrorMessage] = useState<any>("");
    const generalContext = useContext(GeneralDataContext);
    const {
        financialPage: { financialData: isFinancialUpdate },
    } = generalContext;

    useEffect(() => {
        setInputValue(defaultValue);
    }, [defaultValue]);

    const handleInputTypes = (event: any) => {
        let inputVal = defaultValue;
        if (input.type === "checkbox") {
            inputVal = event.target.checked;
        } else if (input?.flag === "offline_factor") {
            inputVal = event.target?.value || event.vendor_id;
        } else {
            inputVal = event.target?.value || event.id;
        }
        setInputValue(inputVal);
    };

    const onChange = (event: any) => {
        if (input.type === "upload") {
            setInputValue(event);
            if (handleChange) {
                handleChange(event);
            }
        } else if (input.type === "float-number") {
            let validNumber = event.target.value;
            if (validNumber?.includes("٫")) {
                validNumber = validNumber.replace(/٫/g, ".");
            }
            if (validNumber?.includes("/")) {
                validNumber = validNumber.replace(/\//g, ".");
            }
            const EnNmber = persianToEnglishNumber(validNumber);
            setInputValue(event.target?.value);
            if (handleChange) {
                handleChange(EnNmber);
            }
        } else if (input.type === "date") {
            if (input.name === "end") {
                setInputValue(defaultValue ? event : "");
            } else {
                setInputValue(defaultValue);
            }
            setInputValue(defaultValue);
            if (handleChange) {
                handleChange(defaultValue || event);
            }
        } else {
            handleInputTypes(event);
            const phoneno = /^[0-9]*$/;
            if (event.target?.name === "phone") {
                const englishNum = toEnglishNum(event.target?.value);
                isValid &&
                    handleChange &&
                    handleChange(englishNum || event.target.value);
                if (englishNum && +englishNum > 0) {
                    englishNum.match(phoneno) && englishNum.length <= 11
                        ? setIsValid(true)
                        : setIsValid(false);
                } else {
                    event.target.value.match(phoneno) &&
                    event.target.value.length <= 11
                        ? setIsValid(true)
                        : setIsValid(false);
                }
            } else if (input.type === "number-english") {
                setInputValue(
                    persianToEnglishNumber(event.target.value)?.replace(
                        /\D/g,
                        ""
                    )
                );
                handleChange &&
                    handleChange(
                        persianToEnglishNumber(event.target.value)?.replace(
                            /\D/g,
                            ""
                        )
                    );
            } else {
                if (handleChange && input.type === "checkbox") {
                    handleChange(event.target?.checked);
                } else if (handleChange) {
                    if (input?.flag === "offline_factor") {
                        handleChange(event.target?.value || event.vendor_id);
                    } else handleChange(event.target?.value || event.id);
                }
            }
        }
    };
    const commaOnChange = (event: any) => {
        onChange(event);
        if (event.target.value.includes(".")) {
            return setErrorMessage(
                "امکان وارد کردن مبلغ به صورت اعشاری وجود ندارد"
            );
        }
        if (
            !Number.isInteger(Number(removeCamma(event.target.value))) ||
            Number(removeCamma(event.target.value)) <= 0
        ) {
            return setErrorMessage("مبلغ وارد شده صحیح نیست");
        } else {
            setErrorMessage("");
        }
    };

    const floatOnChange = (event: any) => {
        onChange(event);
        const EnNmber = persianToEnglishNumber(event.target.value);
        const floatNumberReg = /^[+-]?\d+([.,٫]\d+)?(\/[+-]?\d+([.,٫]\d+)?)?$/;
        if (event.target.value === "") {
            setErrorMessage(undefined);
        } else {
            const value = floatNumberReg.test(EnNmber);
            return value
                ? setErrorMessage(undefined)
                : setErrorMessage("فقط اعداد صحیح و اعشاری وارد شود");
        }
    };

    useEffect(() => {
        //TODO: check here
        if (reset && !defaultValue) {
            setInputValue("");
        }
    }, [reset]);

    const generateInput = (input: InputTypes, startDate?: string) => {
        switch (input.type) {
            case "select":
                return (
                    <FormSelectBox
                        input={input}
                        value={inputValue}
                        name={input.name}
                        // @ts-ignore
                        hasNotShowAll={Boolean(input.hasNotShowAll)}
                        disabledSelect={disabled || input.disable}
                        defaultValue={inputValue !== "" ? inputValue : 0}
                        onChange={onChange}
                    />
                );
            case "json":
                return (
                    <FormSelectBox
                        input={input}
                        defaultValue={defaultValue}
                        value={inputValue ?? ""}
                        disabledSelect={disabled}
                        // @ts-ignore
                        onChange={onChange}
                    />
                );
            case "textarea":
                return (
                    <Form.Control
                        as="textarea"
                        name={input.name}
                        disabled={disabled}
                        // defaultValue={defaultValue}
                        value={inputValue}
                        onChange={onChange}
                    />
                );
            case "text":
                return (
                    <>
                        <Form.Control
                            type="text"
                            name={input.name}
                            disabled={disabled}
                            // defaultValue={defaultValue}
                            value={inputValue ?? ""}
                            onChange={onChange}
                        />
                        {input.name === "phone" && !isValid && (
                            <span className="error-msg">
                                شماره تلفن تنها شامل عدد و حداکثر ۱۱ رقم میباشد.
                            </span>
                        )}
                    </>
                );
            case "number-english":
                return (
                    <Form.Control
                        type="tel"
                        name={input.name}
                        disabled={disabled}
                        inputMode="numeric"
                        pattern="\d*"
                        // defaultValue={defaultValue}
                        value={inputValue}
                        onChange={onChange}
                    />
                );
            case "hidden":
                return (
                    <Form.Control
                        type="hidden"
                        name={input.name}
                        disabled={disabled}
                        // defaultValue={defaultValue}
                        value={inputValue || defaultValue}
                        onChange={onChange}
                    />
                );
            case "number":
                return (
                    <Form.Control
                        type="number"
                        name={input.name}
                        disabled={disabled}
                        min="0"
                        defaultValue={inputValue || defaultValue}
                        value={inputValue ?? 0}
                        onChange={(e) => onChange(e)}
                    />
                );
            case "number-without-zero":
                return (
                    <Form.Control
                        type="number"
                        name={input.name}
                        disabled={disabled}
                        min="0"
                        defaultValue={inputValue || defaultValue}
                        value={inputValue}
                        onChange={(e) => onChange(e)}
                    />
                );
            case "float-number":
                return (
                    <>
                        <Form.Control
                            type="text"
                            name={input.name}
                            disabled={disabled}
                            value={inputValue ?? ""}
                            onChange={floatOnChange}
                        />
                        {errorMessage && (
                            <span className={style.error_msg}>
                                {errorMessage}
                            </span>
                        )}
                    </>
                );
            case "number-comma":
                return (
                    <>
                        <Form.Control
                            type="text"
                            name={input.name}
                            disabled={disabled}
                            value={inputValue}
                            onChange={commaOnChange}
                        />
                        {errorMessage && (
                            <span className={style.error_msg}>
                                {errorMessage}
                            </span>
                        )}
                    </>
                );
            case "string":
                return (
                    <Form.Control
                        type="text"
                        name={input.name}
                        disabled={true}
                        value={inputValue || defaultValue}
                        onChange={onChange}
                    />
                );
            case "checkbox":
                return (
                    <Form.Check
                        type="checkbox"
                        name={input.name}
                        checked={inputValue ?? ""}
                        disabled={disabled}
                        defaultChecked={defaultValue}
                        onClick={onChange}
                    />
                );
            case "upload":
                return (
                    <FileUploader
                        // @ts-ignore
                        title={input.title}
                        handleFileUpload={onChange}
                    />
                );
            case "tag":
                return (
                    <TagInput name={input.name} defaultValue={defaultValue} />
                );
            case "date":
                const date = inputValue || defaultValue || startDate;
                if (input.name === "start" && date) {
                    return (
                        <Form.Control
                            type="text"
                            name={input.name}
                            disabled={true}
                            value={date}
                            onChange={onChange}
                        />
                    );
                } else {
                    const persianEndDate = isFinancialUpdate
                        ? date
                        : inputValue || defaultValue;
                    return (
                        <>
                            {isFinancialUpdate ? (
                                <Form.Control
                                    type="text"
                                    name={input.name}
                                    disabled={true}
                                    value={persianEndDate}
                                    onChange={onChange}
                                />
                            ) : (
                                <>
                                    {persianEndDate ? (
                                        <DatePicker
                                            getSelectedDate={onChange}
                                            name={input.name}
                                            defaultValue={persianEndDate}
                                            min={
                                                input.fromToday
                                                    ? momentJalaali().subtract(
                                                          1,
                                                          "day"
                                                      )
                                                    : undefined
                                            }
                                        />
                                    ) : (
                                        <DatePicker
                                            getSelectedDate={onChange}
                                            name={input.name}
                                            defaultValue={persianEndDate}
                                            min={
                                                input.fromToday
                                                    ? momentJalaali().subtract(
                                                          1,
                                                          "day"
                                                      )
                                                    : undefined
                                            }
                                        />
                                    )}
                                </>
                            )}
                        </>
                    );
                }
            default:
                return (
                    <Form.Control
                        type="textarea"
                        name={input.name}
                        disabled={disabled}
                        // defaultValue={defaultValue}
                        value={inputValue || defaultValue}
                        onChange={onChange}
                    />
                );
        }
    };

    return (
        <>
            <Form.Group
                className={`${
                    input.type === "checkbox"
                        ? style.checkbox
                        : style.inputWidth
                }  ${hasError && input.required && (!inputValue || (input.noZero && inputValue === "0")) ? style.hasError : ""}`}
                data-testid="Input__FormGroup"
            >
                {input.type !== "checkbox" && (
                    <Form.Label className={disabled ? style.disabled : ""}>
                        {`${input.label} ${
                            input.hasCostumeTitle && costumeTitle
                                ? `(${costumeTitle})`
                                : ""
                        }`}
                        {input.required && (
                            <span className={style.required}>*</span>
                        )}
                    </Form.Label>
                )}
                {generateInput(input, startDate)}
                {input.type === "checkbox" && (
                    <Form.Label>
                        {`${input.label}${
                            input.hasCostumeTitle && costumeTitle ? (
                                `(${costumeTitle})`
                            ) : input.required ? (
                                <span className="required">*</span>
                            ) : (
                                ""
                            )
                        }`}
                    </Form.Label>
                )}
            </Form.Group>
        </>
    );
};

export default Input;
